let commonStore = {
  state: {
    loading:false,
  },
  getters: {
    loading: state => state.loading,
  },
  mutations: {
    setLoading(state,loading){
      state.loading = loading;
    },
  },
  actions: {}
}
export default commonStore;
